
/*
 *	by Brian Corr 
 *		BrianCorr@BrianCorr.io
 *
 *		v 0.7.4
 *	- fixed a bug in MaserTicker where elapse was not a frame elapse but elapse since init. 
 *		This didn't affect timelineCTRLs but did affect ad-hoc functions sent to MaserTicker.
 *
 *		v 0.7.3
 *	- added runFromBeginning() to Animation Controller
 *	- MaterTicker no longer echos "STOP FAIL" on a failed stop request, given that this is often called for just-in-case purposes
 *
 *		v 0.7.2
 *	- changed teh CorrCureve interface
 *
 *		v 0.7.1
 *	- added an inverse CorrCurve function	
 *
 *		v 0.7.0
 *	- changed the name to AnimateState 
 *	- big changes to MasterTicker, added features that allow the user to add onFrame functions to MasterTicker that will receive a frame-elapse
 *		This is to allow the use of MasterTicker to control animations that don't have a duration, like particle engines, etc.
 *	- changed all appearances of "this" to "instance" to reference the the instance directly, that way we keep scope even if the function is aliased 
 *
 *		v - 0.6.4
 *	- added a setDuration function and set some better var names in Controller 
 *	- fixed a divide by 0 error on switches (we default to post state if at = start = end)
 *
 *	- added loop feature to the Animation Controller 
 *	- Better reuse of child timelines: Timeline.frame() - instead of immediately calling the child frame() function add it to a list. 
 *		If there is already a call to that child's frame overwrite it with the new one. 
 *  - added option to MasterTicker to run itself OR to have its frame called (presumably by the central onFrame of the app)
 *	- added Corr Curve function for tweening and lerp
 *  - added in-order pre and post setting so we can reuse timelines 
 *  - removed ease from AnimationController
 *	- added masterEase to timeline
 *	
 *	- added externalStateDispupt() to allow different child timelines to manipulate the same data
 *		in which case the USER should call externalStateDispupt() on all timelines that manipulate that data
 *	
 *	- added modulo (because JS's is wrong regarding negative numbers)
 *
 *	TODO: 
 *	- add CorrCurve defined by midPoint and curve vars in addition to define by c0 and c1
 *	- add to Timeline, the ability to add a marker that is unattached to a childTimeline for adding leader and trailer space
 *	- make intricate animation example 
 *	- make button animation example 
 *	- make example fed by scroll position 
 *	- make example where we use it as just a state machine 
 *	- make particle example using the new functionality of MasterTicker 
 *	- fully test the new functionaility of MasterTicker
 *	- change over the examples to use the new name
 * 
 */

var AnimateState = new Object();


// --- Mater Ticker --- //

/*
 * Who runs Animation Town? 
 * Master Ticker runs Animation Town!!!
 *
 * MaterTicker is a singleton used by the AnimationControllers to call frame() on the proper interval.
 * If you have a central onFrame function for your project set AnimateState.MaterTicker.autoFrame = false 
 * and call AnimateState.MaterTicker.frame() from your central onFrame function. 
 * If not AnimateState.MaterTicker.autoFrame deafult is true, so MasterTicker will automatically call it's own frame function.
 * 
 * If autoFrame is true, the user can set the frame rate in the following ways:
 * 
 * setFrameRate(frameRate)
 * 		to set the frame rate to X frames per second which then sets the interval between frames accordingly
 * 
 * setFrameInterval(frameInterval)
 * 		set the interval between frames to X milliseconds, it then sets the frame rate accordingly
 *
 * notes:
 * 	- If you want to set the frame rate (or interval) do it before calling run() on any AnimationControllers.
 * 		We use setInterval meaning changing the frame rate has no effect until MasterTicker is reset. 
 * 		If we want on-the-fly frame rate change we'd use setTimeOut re-calling ever frame using the (possibly new) framerate.
 * 
 * 
 */

AnimateState.MaterTicker = new Object();

AnimateState.MaterTicker.doStats = false;

AnimateState.MaterTicker.isRunning = false;
AnimateState.MaterTicker.queue = [];
AnimateState.MaterTicker.nextId = 1;

AnimateState.MaterTicker.nowT = 0.0;
AnimateState.MaterTicker.elapse = 0.0;
AnimateState.MaterTicker.prevFrameT = 0.0;
AnimateState.MaterTicker.initT = 0.0;

AnimateState.MaterTicker.avgElapse = 0.0;
AnimateState.MaterTicker.frameCount = 0;


window.requestAnimFrame = (function() {
	return window.requestAnimationFrame ||
         window.webkitRequestAnimationFrame ||
         window.mozRequestAnimationFrame ||
         window.oRequestAnimationFrame ||
         window.msRequestAnimationFrame ||
         function(/* function FrameRequestCallback */ callback, /* DOMElement Element */ element) {
         	window.setTimeout(callback, 1000/60);
         };
})();

AnimateState.MaterTicker.run = function(){
	if (AnimateState.MaterTicker.isRunning) return; // already running 
	AnimateState.MaterTicker.isRunning = true;
	
	// reset the vars before running
	AnimateState.MaterTicker.nowT = 0.0;
	AnimateState.MaterTicker.elapse = 0.0;
	AnimateState.MaterTicker.prevFrameT = 0.0;
	AnimateState.MaterTicker.initT = 0.0;
	AnimateState.MaterTicker.avgElapse = 0.0;
	AnimateState.MaterTicker.frameCount = 0;
	
	AnimateState.MaterTicker.frame();
};

AnimateState.MaterTicker.stop = function(){
	AnimateState.MaterTicker.isRunning = false;
};


AnimateState.MaterTicker.addToQueue = function(frameFn){
	if (typeof frameFn != "function") return 0;// not runnable by Master Ticker 
	var queueId = AnimateState.MaterTicker.nextId;
	AnimateState.MaterTicker.nextId ++;
	AnimateState.MaterTicker.queue.push( {id:queueId, frame:frameFn} );
	AnimateState.MaterTicker.run();
	
	return queueId;
};

AnimateState.MaterTicker.removeFromQueue = function(animCtrlId){
	var queue = AnimateState.MaterTicker.queue;
	var index = -1;
	var i;
	for (i = 0; i < queue.length; i++){
		if (queue[i].id == animCtrlId){
			index = i;
			break;
		}
	}
	
	if (index == -1){
		//console.log("STOP FAIL");
		return; // id not found
	}
	
	return queue.splice(index, 1)[0]; // return child instance
};

AnimateState.MaterTicker.frame = function(){
	if (!AnimateState.MaterTicker.isRunning) return;
	
	if (AnimateState.MaterTicker.queue.length <= 0){
		AnimateState.MaterTicker.stop();
		AnimateState.MaterTicker.nextId = 1;
		return;
	}
	
	AnimateState.MaterTicker.prevFrameT = AnimateState.MaterTicker.nowT;
	AnimateState.MaterTicker.nowT = new Date().getTime();
	if (AnimateState.MaterTicker.prevFrameT == 0.0) {
		AnimateState.MaterTicker.initT = AnimateState.MaterTicker.prevFrameT = AnimateState.MaterTicker.nowT;
		window.requestAnimFrame(AnimateState.MaterTicker.frame);
		return;
	}
	
	AnimateState.MaterTicker.elapse = AnimateState.MaterTicker.nowT - AnimateState.MaterTicker.prevFrameT;
	
	// - stat keeping - //
	if (AnimateState.MaterTicker.doStats){
		AnimateState.MaterTicker.frameCount++;
		var frameWeight = 1/AnimateState.MaterTicker.frameCount;
		AnimateState.MaterTicker.avgElapse = (AnimateState.MaterTicker.avgElapse * (1-frameWeight)) + (AnimateState.MaterTicker.elapse * frameWeight);
	}
	
	var i;
	for (i = 0; i < AnimateState.MaterTicker.queue.length; i++){
		AnimateState.MaterTicker.queue[i].frame(AnimateState.MaterTicker.elapse);
	}
	
	window.requestAnimFrame(AnimateState.MaterTicker.frame);
};


// --- Timelines --- //

/*
 * Timeline
 * 
 * Timelines are kind of hierarchically stackable sliding-state machines. Where the state is a value between 0 and 1. 
 * 
 * You control what happens on statecahnge with the onFrame function. There are also two special states, 0 and 1, 
 * that you can control the effect of with onSetToPre and onSetToPost respectively. 
 * All other states are considered degrees of the animation state.
 * 
 * onInit is run before moving from a pre or post state into an animation state. 
 * For example of you need to wrap a div before animating it.
 * 
 * onDeInit is run after moving from an animation state to either pre or post states. 
 * For example to unwrap our hypothetical div.
 * 
 * All function callbacks should be idempotent! 
 * Meaning, for example, calling onSetToPost twice in a row will have the same effect as calling it once.
 * for example 
 * 		displayNum += 1
 * is NOT idempotent
 * 		displayNum = 5
 * IS idempotent
 * 
 * Hierarchically stackable means any timeline can have unlimited child timelines.
 * 
 * Each child timeline has a begin and end marker in the parent timeline. 
 * (note the end marker can come before the begin marker to run the child in reverse)
 * Markers are in "marker units" relitave only to each other and will scale with duration. 
 * Think of marker units like "parts" in a cocktail recipe that scales with the serving size of the drink.
 * The timeline will begin at marker 0 or the lowest marker under 0 and end at 0 or the largest marker above 0.
 * 
 * 
 */

AnimateState.timelineCount = 0;

AnimateState.makeChildTimeline = function(timeline, beginMark, endMark, instanceId){
	var instance = new Object();
	instance.timeline = timeline;
	instance.beginMark = instance.leastMark = beginMark;
	instance.endMark = instance.greatestMark = endMark;
	
	if (instance.greatestMark < instance.leastMark){
		instance.leastMark = endMark;
		instance.greatestMark = beginMark;
	}
	
	instance.instanceId = instanceId;
	
	return instance;
};


AnimateState.makeTimeline = function(){
	var instance = new Object();
	
	instance.id = AnimateState.timelineCount;
	AnimateState.timelineCount ++;
	
	instance.PRE_STATE = "animation pre state";
	instance.ANIMATE_STATE = "animation animate state";
	instance.POST_STATE = "animation post state";
	instance.UNKNOWN_STATE = "animation unknown state";
	
	
	instance.isInitalised = false;
	instance.atPct = 0.0;
	instance.atMark = 0.0;
	//instance.state = instance.PRE_STATE;// UNKNOWN_STATE was causing problems when the same function was used multuple times on a single timeline
	instance.state = instance.UNKNOWN_STATE;
	
	instance.leastMark = 0;
	instance.greatestMark = 0;
	
	instance.instanceIdCount = 0;
	instance.children = [];
	instance.childrenByLeast = [];
	instance.childrenByGreatest = [];
	
	instance.externalStateDisrupt = function(){
		instance.state = instance.UNKNOWN_STATE;
	}
	
	instance.containsTimeline = function(timeline){
		if (instance == timeline) return true;
		
		var isContains = false;
		var i;
		for (i = 0; i < instance.children.length; i++){
			if ( instance.children[i].timeline.containsTimeline(timeline) ){
				isContains = true;
				break;
			}
		}
		
		return isContains;
	};
	
	instance.checkMarkers = function(beginMark, endMark){
		if (beginMark < instance.leastMark) instance.leastMark = beginMark;
		if (endMark < instance.leastMark) instance.leastMark = endMark;
		
		if (instance.greatestMark < beginMark) instance.greatestMark = beginMark;
		if (instance.greatestMark < endMark) instance.greatestMark = endMark;
	};
	
	instance.addChild = function(timeline, beginMark, endMark, isSkipError){
		// to enable skipping the error check (performance tuning for projects with deeply nested timelines that are added and removed often during runtime) 
		//	uncomment the conditional below. But BE WARNED you can very easily end up with an infinite loop!
		//if (typeof isSkipError == 'undefined') 
		isSkipError = false;
		
		if ( !isSkipError && timeline.containsTimeline(instance) ){
			console.log("Error: timeline id:"+timeline.id+" contains timeline id:"+instance.id+" so can not be added as a child of timeline id:"+instance.id+". Infinite loops are bad in most situations.");
			return;
		}
		
		instance.checkMarkers(beginMark, endMark);
		
		var newChild = AnimateState.makeChildTimeline(timeline, beginMark, endMark, instance.instanceIdCount);
		instance.children.push( newChild );
		
		var i;
		var insertAt;
		// TODO: use the bisection array search method
		insertAt = instance.childrenByLeast.length;
		for (i = 0; i < instance.childrenByLeast.length; i++){
			if (instance.childrenByLeast[i].leastMark > newChild.leastMark){
				insertAt = i;
				break;
			}
		}
		instance.childrenByLeast.splice(insertAt, 0, newChild);
		
		insertAt = instance.childrenByGreatest.length;
		for (i = 0; i < instance.childrenByGreatest.length; i++){
			if (instance.childrenByGreatest[i].greatestMark > newChild.greatestMark){
				insertAt = i;
				break;
			}
		}
		instance.childrenByGreatest.splice(insertAt, 0, newChild);
		
		instance.instanceIdCount ++;
		return instance.instanceIdCount-1;
	};
	
	
	instance.removeChildByInstanceId = function(instanceId){
		var index = -1;
		var i;
		for (i = 0; i < instance.children.length; i++){
			if (instance.children[i].instanceId == instanceId){
				index = i;
				break;
			}
		}
		
		if (index == -1) return; // id not found
		
		return instance.removeChildByIndex(index);
	};
	
	
	instance.removeChild = function(timeline){
		var index = -1;
		var i;
		for (i = 0; i < instance.children.length; i++){
			if (instance.children[i].timeline == timeline){
				index = i;
				break;
			}
		}
		
		if (index == -1) return; // id not found
		
		return instance.removeChildByIndex(index);
	};
	
	instance.removeChildByIndex = function(index){
		// remove the timeline and store it
		var removedTimeline = instance.children.splice(index, 1)[0].timeline;
		
		var removeAt;
		var i;
		// TODO: use the bisection array search method
		removeAt = -1;
		for (i = 0; i < instance.childrenByLeast.length; i++){
			if (instance.childrenByLeast[i].instanceId == removedTimeline.instanceId){
				removeAt = i;
				break;
			}
		}
		if (removeAt != -1) instance.childrenByLeast.splice(removeAt, 1);
		
		removeAt = -1;
		for (i = 0; i < instance.childrenByGreatest.length; i++){
			if (instance.childrenByGreatest[i].instanceId == removedTimeline.instanceId){
				removeAt = i;
				break;
			}
		}
		if (removeAt != -1) instance.childrenByGreatest.splice(removeAt, 1);
		
		// find new least and greatest marks 
		instance.leastMark = 0;
		instance.greatestMark = 0;
		for (var i = 0; i < instance.children.length; i++){
			instance.checkMarkers(instance.children[i].beginMark, instance.children[i].endMark);
		}
		
		return removedTimeline;
	};
	
	
	// settable by user
	instance.onInit = function(){
		
	};
	
	instance.onDeInit = function(){
		
	};
	
	instance.onSetToPre = function(){
		
	};
	
	instance.onSetToPost = function(){
		
	};
	
	instance.onFrame = function(pct){
		
	};
	
	instance.masterEase = function(pct){
		return pct;
	};
	
	
	// internal
	instance.init = function(){
		instance.onInit();
		instance.isInitalised = true;
		instance.state = instance.ANIMATE_STATE;
	};
	
	instance.deInit = function(){
		instance.onDeInit();
		instance.isInitalised = false;
	};
	
	instance.setToPre = function(){
		instance.onSetToPre();
		instance.deInit();
		instance.state = instance.PRE_STATE;
	};
	
	instance.setToPost = function(){
		instance.onSetToPost();
		instance.deInit();
		instance.state = instance.POST_STATE;
	};
	
	// helper functions for frame()
	instance.makeOnFrameDatum = function(child, atMark){
		var childPct;
		if (child.endMark == child.beginMark){
			if (atMark < child.beginMark){
				childPct = 0;
			}else{
				childPct = 1;
			}
		}else{
			childPct = (atMark - child.beginMark) / (child.endMark - child.beginMark);
		}
		var frameDatum = new Object();
		frameDatum.child = child;
		frameDatum.pct = childPct;
		return frameDatum;
	};
	
	// we assume all elements in the array are unique
	instance.pruneById = function(frameDataList, tlID){
		var indexToPrune = -1;
		var i;
		for (i=0; i<frameDataList.length; i++){
			if (tlID == frameDataList[i].child.timeline.id){
				indexToPrune = i;
				break;
			}
		}
		if (-1 != indexToPrune) frameDataList.splice(indexToPrune, 1);
		
		return frameDataList;
	};
	
	
	instance.frame = function(pct){
		//console.log(instance.id +': '+pct);
		if (pct >= 1){
			// have we already set the post state and deinitalised? 
			if (!instance.isInitalised && instance.state == instance.POST_STATE) return;
			pct = 1;
		}else if (pct <= 0){
			// have we already set the pre state and deinitalised? 
			if (!instance.isInitalised && instance.state == instance.PRE_STATE) return;
			pct = 0;
		}else{
			// we're going to a place on the animation line
			pct = instance.masterEase(pct);
		}
		
		// This is outside the above else-block so that in a switch you still get the onInit call 
		if (!instance.isInitalised) instance.init();
		
		// look through child timelines and call them
		instance.atPct = pct;
		instance.atMark = ((instance.greatestMark - instance.leastMark) * pct) + instance.leastMark; // lerp
		var child;
		var i;
		
		
		// if we want to reuse timelines we need to check these states in a particular order
		//	and for efficiency we'll only run each child once by making a list first  
		
		var frameDataList = [];
		var frameDataMap = {};
		
		// helper function
		var addChildToFrameList = function(child, atMark){
			var frameDatum = instance.makeOnFrameDatum(child, atMark);
			var tlID = child.timeline.id;
			if ('undefined' != typeof frameDataMap[tlID.toString()]){
				// we have a previous entry
				frameDataList = instance.pruneById(frameDataList, tlID);
			}
			frameDataMap[tlID.toString()] = frameDatum.pct;
			frameDataList.push(frameDatum);
		}
		
		// start at the end and pre-set all TL's that begin in the future
		for (i = instance.childrenByLeast.length-1; i >= 0; i--){ // NOTE: DECRIMENT!!!
			child = instance.childrenByLeast[i];
			if (child.leastMark > instance.atMark){
				addChildToFrameList(child, instance.atMark);
			}else{
				break; //since they are in order we can break early 
			}
		}
		
		// start at the beginning and post-set all the TLs that end in the past
		for (i = 0; i < instance.childrenByGreatest.length; i++){
			child = instance.childrenByGreatest[i];
			if (child.greatestMark < instance.atMark){
				addChildToFrameList(child, instance.atMark);
			}else{
				break; //since they are in order we can break early 
			}
		}
		
		// look through the main list and on-frame all active TLs
		for (i = 0; i < instance.children.length; i++){
			child = instance.children[i];
			if( child.leastMark <= instance.atMark && child.greatestMark >= instance.atMark){
				addChildToFrameList(child, instance.atMark);
			}
		}
		
		
		// call all the onFrames in our list in order
		for (i = 0; i < frameDataList.length; i++){
			var frameDatum = frameDataList[i];
			frameDatum.child.timeline.frame(frameDatum.pct);
		}
		
		// call our own 
		instance.onFrame(pct);
		
		if (pct >= 1){
			instance.setToPost();
		}else if (pct <= 0){
			instance.setToPre();
		}
	};
	
	// --- //
	
	return instance;
};



// --- Animation Controllers --- //

/*
 * Animation Controllers
 * 
 * Animation Controllers are kind of like a playhead for a timeline. 
 * They control the duration, starting, stoping, figuring the animation percentage, etc.
 * A Timeline (as stated above) is kind of sliding state machine where the state is any value between 0 and 1.
 * An Animation Controller turns that state machine into an animation. 
 * 
 * duration
 * 		duration of animation in millisecond
 * 
 * stop()
 * 		stops the animation by pulling it from MasterTicker's queue, does not jump the animation to the end
 * 
 * run(isReverse, isLoop, duration)
 * 		starts the animation from it's current point, the duration is adjusted for the current point of the animation, 
 * 		you can send 'true' for "isReverse" to run the animation from its current point back to the begining 
 * 		If you want the animation to loop send true for isLoop.
 * 		if you want to override the default duration send a value for duration.
 *  
 * setAnimationToPercent(pct)
 *  	while the animation is stopped you can jump the animation to the defined point, 
 *  	useful if you want to run an animtion from the begining regardles of its current position
 *  	you'd call setAnimationToPercent(0) before calling run()
 *  
 * 
 */

AnimateState.makeAnimationController = function(duration, timeline){
	if (typeof duration == 'undefined') duration = 1000;// milliseconds, default
	if (typeof timeline == 'undefined') timeline = AnimateState.makeTimeline();// if no timeline from user: make a new one
	
	var instance = new Object();
	
	instance.currentDuration = duration;
	instance.defaultDuration = duration;
	instance.timeline = timeline;
	instance.isRunning = false;
	instance.runTime = new Date().getTime();
	instance.isReverse = false;
	instance.isLoop = false;
	instance.tickerId = 0;
	
	instance.setDuration = function(duration){
		instance.currentDuration = duration;
		instance.defaultDuration = duration;
	};
	
	instance.setAnimationToPercent = function(pct){
		instance.timeline.frame(pct);
	};
	
	instance.stop = function(){
		AnimateState.MaterTicker.removeFromQueue(instance.tickerId);
		instance.isRunning = false;
	};
	
	instance.runFromBeginning = function(isReverse, isLoop, duration){
		if (typeof isReverse == 'undefined') isReverse = false;
		if (instance.isRunning) instance.stop();
		if (isReverse){
			instance.setAnimationToPercent(1.0);
		}else{
			instance.setAnimationToPercent(0.0);
		}
		
		instance.run(isReverse, isLoop, duration);
	};
	
	instance.run = function(isReverse, isLoop, duration){
		if (instance.isRunning) instance.stop();
		if (typeof isReverse == 'undefined') isReverse = false;
		instance.isReverse = isReverse;
		
		if (typeof isLoop == 'undefined') isLoop = false;
		instance.isLoop = isLoop;
		
		if (typeof duration == 'undefined') duration = instance.defaultDuration;
		instance.currentDuration = duration;
		
		instance.runTime = new Date().getTime();
		
		var offsetPct = instance.timeline.atPct;
		if (instance.isReverse) offsetPct = 1 - offsetPct;
		instance.runTime -= offsetPct * instance.currentDuration;
		
		instance.isRunning = true;
		
		instance.tickerId = AnimateState.MaterTicker.addToQueue(instance.frame);
	};
	
	instance.frame = function(frameElapse){
		var nowTime = new Date().getTime();
		var elapse = nowTime - instance.runTime;
		var pct = elapse/instance.currentDuration;
		var sendPct = pct;
		if (0 > sendPct) sendPct = 0;
		if (1 < sendPct) sendPct = 1;
		if (instance.isReverse) sendPct = 1 - sendPct;
		
		instance.timeline.frame(sendPct);
		
		if (pct >= 1){
			if (instance.isLoop){
				instance.runTime += Math.floor(pct) * instance.currentDuration;
				instance.frame();
			}else{
				instance.stop();
			}
		}
	};
	
	
	return instance;
};


// --- Tweening Utilities --- //
/*
AnimateState.findOnSimpleCorrCurve_Old = function(ptX, flatCrlX, peakCrlX){
	var ptY;
	if(ptX>=1){
		ptY = 1;
	}else if (ptX<=0){
		ptY=0;
	}else{
		var xPct = ptX;
		var flexPtX = ((peakCrlX - flatCrlX)*xPct)+flatCrlX;
		var flexPtY = xPct;
	
		if (ptX == flexPtX){
			ptY = flexPtY;
		}else if (ptX < flexPtX){
			ptY = (flexPtY*(ptX/flexPtX));
		}else if (ptX > flexPtX){
			ptY = 1+((flexPtY - 1)*((ptX-1)/(flexPtX-1)));
		}
		
	}
	
	return ptY;
};
*/

AnimateState.findOnSimpleCorrCurve = function(x, c0, c1){
	var y;
	
	if(x>=1){
		y = 1;
	}else if (x<=0){
		y=0;
	}else{
		var curve = ((1-c1)+c0);
		var m = c0 / curve;
		var doRotate = false;
		
		if (x>m) doRotate = true;
		
		if (doRotate){
			x = 1-x;
			var swap = c0;
			c0 = 1-c1;
			c1 = 1-swap;
		}
		
		y = Math.pow(x, 2) / (((c1-c0)*x)+c0);
		
		if (doRotate){
			y = 1-y;
		}
	}
	
	return y;
}

AnimateState.findOnSimpleInverseCorrCurve = function(x, c0, c1){
	var y;
		
	if(x>=1){
		y = 1;
	}else if (x<=0){
		y=0;
	}else{
		var curve = ((1-c1)+c0);
		var m = c0 / curve;
		var doRotate = false;
		
		if (x>m) doRotate = true;
		
		if (doRotate){
			x = 1-x;
			var swap = c0;
			c0 = 1-c1;
			c1 = 1-swap;
		}
	
		var bx = c1*x;
		var ax = c0*x;
	
		y = -((-bx+ax-Math.sqrt(Math.pow(bx-ax, 2)+(4*ax)))*0.5);
		
		if (doRotate){
			y = 1-y;
		}
	}
		
	return y;
};

// --- //
/* 
The new interface prefers defining the curve by Intercept and Curve Severity. Though you can also use control points. 
Also the previous definitions for c0 and c1 were x coordinates. Now we define them by length. c0Len = c0X, c1Len = 1 - c0X

m: The intercept of the Corr Curve and the line y=x. This defines the scaling of the two sides of the curve. 
v: The "curve severity" where 0 is a straight line and Infinity is a square curve. 
For a good visualizer go to: https://briancorr.io/corrcurve 
*/

AnimateState.findOnInverseCorrCurve = function(x, m, v){
	//c1 = 1-c1;
	var y;
		
	if(x>=1){
		y = 1;
	}else if (x<=0){
		y=0;
	}else{
		//var curve = ((1-c1)+c0);
		//var m = c0 / curve;
		var doRotate = false;
		
		var c0 = m * v;
		var c1 = (1-m) * v;
		c1 = 1-c1;// translate from Length to X 
		
		if (x>m) doRotate = true;
		
		if (doRotate){
			x = 1-x;
			var swap = c0;
			c0 = 1-c1;
			c1 = 1-swap;
		}
	
		var bx = c1*x;
		var ax = c0*x;
	
		y = -((-bx+ax-Math.sqrt(Math.pow(bx-ax, 2)+(4*ax)))*0.5);
		
		if (doRotate){
			y = 1-y;
		}
	}
		
	return y;
};


AnimateState.findOnCorrCurve = function(x, m, v){
	//c1 = 1-c1;
	var y;
	
	if(x>=1){
		y = 1;
	}else if (x<=0){
		y=0;
	}else{
		//var v = ((1-c1)+c0);
		//var m = c0 / v;
		var doRotate = false;
		
		var c0 = m * v;
		var c1 = (1-m) * v;
		c1 = 1-c1;// translate from Length to X 
		
		if (x>m) doRotate = true;
		
		if (doRotate){
			x = 1-x;
			var swap = c0;
			c0 = 1-c1;
			c1 = 1-swap;
		}
		
		y = Math.pow(x, 2) / (((c1-c0)*x)+c0);
		
		if (doRotate){
			y = 1-y;
		}
	}
	
	return y;
}

AnimateState.findOnCorrCurveCTRL = function(x, c0, c1){
	var mv = AnimateState.corrCurveGetMVForCTRL(c0, c1);
	return AnimateState.findOnCorrCurve(x, mv.m, mv.v);
}

AnimateState.findOnInverseCorrCurveCTRL = function(x, c0, c1){
	var mv = AnimateState.corrCurveGetMVForCTRL(c0, c1);
	return AnimateState.findOnInverseCorrCurve(x, mv.m, mv.v);
}

AnimateState.corrCurveGetMVForCTRL = function(c0, c1){
	//var v = ((1-c1)+c0);
	var v = c1+c0;
	var m = c0 / v;
	return {'m':m, 'v':v};
}

AnimateState.corrCurveGetCTRLForMV = function(m, v){
	var c0 = m * v;
	var c1 = (1-m) * v;
	
	//c1 = 1-c1;
	return {'c0':c0, 'c1':c1};
}


AnimateState.lerp = function(from, to, pct){
	return ((to - from) * pct) + from;
}

AnimateState.ilerp = function(from, to, at){
	return (at - from)/(to - from);
}

AnimateState.modulo = function(value, base){
	value = value % base;
	if (value < 0) value += base; // because in JS -1 % x == -1
	return value;
};

export default AnimateState
